import React, {useState} from 'react';
import {
    Dropdown,
    Flex,
    Icon,
    IconTrigger,
    PriorityIcon,
    withDropdownContext
} from '@priority-software/priority-style-react';
import {getLocalizedText, texts} from '../../../../constants/TextConst';
import {MenuItem} from './MenuItem';
import Submenu from './Submenu';
import styles from '../../style/Submenu.module.scss';
import {sendMonitor} from '../../../../utils/monitoring';
import classNames from 'classnames';
import {featuresIDs} from '../../../../features/FeaturePopover/constants/map';
import {showAutomationFeature} from '../../../Macro/actions/macroActions';
import {getCommandName} from '../../../../_shared/GWTBridge/invoke/common';
import {isItemVisible} from '../../utils/isItemVisible';
import {Tooltip} from '../../../../components/Common/Tooltip/index';

export const PageSettings = props => {
    const {topMenu, isRTL, isPopup} = props;

    return (
        <Dropdown
            trigger={
                <Tooltip tooltip={getLocalizedText(texts.designSettingsRules)}>
                    <IconTrigger
                        icon="new_settings"
                        className={classNames(styles.pageSettingsTrigger, styles.newPadding)}
                    />
                </Tooltip>
            }
            openingSide="leftSide"
            onOpen={() => sendMonitor('open settings')}
        >
            <Dropdown.Content>
                <Dropdown.Header
                    title={getLocalizedText(texts.moreOptions)}
                    componentClasses="dropdown-menu-header"
                />
                <div className={styles.megaContent}>
                    {topMenu.pageSettings &&
                        topMenu.pageSettings.map((section, index) => {
                            return (
                                isItemVisible(section, isPopup) && (
                                    <MenuSection
                                        key={index}
                                        section={section}
                                        isRTL={isRTL}
                                        isPopup={isPopup}
                                        isLast={index === topMenu.pageSettings.length - 1}
                                    />
                                )
                            );
                        })}
                </div>
            </Dropdown.Content>
        </Dropdown>
    );
};

const Item = ({divider, item, isPopup, index, isRTL}) => {
    const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
    const onClick = item => {
        if (item.submenu) {
            setIsSubmenuOpen(prevState => !prevState);
        } else {
            item.action && item.action(item.command, item.value);
            sendMonitor(`setting item click - ${item.title}`);
        }
    };

    const Title = withDropdownContext(({dropdownContext}) => {
        const cmdId = getCommandName(item.command);
        if (cmdId === 'DlgBusiness' || cmdId === 'DlgData') {
            return (
                <Flex>
                    <div>{item.title}</div>
                    <Icon
                        skin="standart"
                        componentClasses={styles.automationIcon}
                        icon={PriorityIcon.automations}
                        onClick={() => {
                            showAutomationFeature(featuresIDs.automationsFromNewMenu);
                            dropdownContext.closeDropdown();
                        }}
                    />
                </Flex>
            );
        }
        return item.title;
    });

    return (
        isItemVisible(item, isPopup) && (
            <Dropdown.Item
                key={index}
                divider={divider}
                closeOnClick={!item.submenu}
                onClick={() => onClick(item)}
                disabled={item.isDisabled}
            >
                {item.submenu ? (
                    <Submenu
                        options={item.submenu}
                        title={item.title}
                        onChoose={subItem => onClick(subItem)}
                        isRTL={isRTL}
                        tooltip={item.desc}
                        position={isRTL ? 'right center' : 'left center'}
                        delay={1000}
                        isSubmenuOpen={isSubmenuOpen}
                    />
                ) : (
                    <MenuItem
                        tooltip={item.desc}
                        title={<Title />}
                        shortkey={item.shortKey}
                        position={isRTL ? 'right center' : 'left center'}
                        delay={1000}
                        disabled={item.isDisabled}
                    />
                )}
            </Dropdown.Item>
        )
    );
};

const MenuSection = ({section, isRTL, isPopup, isLast}) => {
    const {items} = section;
    return (
        <div className={classNames(styles.subMegaMenu, {[styles.borderedSubMegaMenu]: !isLast})}>
            {items &&
                items.map((item, index) => {
                    return (
                        <Item
                            key={index}
                            item={item}
                            index={index}
                            isPopup={isPopup}
                            isRTL={isRTL}
                            divider={false}
                        />
                    );
                })}
        </div>
    );
};
